{
    "rootURLForQa":  "https://haven-api-qa.azurewebsites.net",
    "rootURLForProd":  "https://api.rbrohaven.com",
    "rootURLForDev":  "https://havenapidev.rbrohaven.com",
    "validateAdminUserCatalog":  "/api/v1/login-admin-user",
    "getUserVerificationCatalog":  "/api/v1/validate-admin-user",
    "updatePasswordCatalog":  "/api/v1/update-password-admin-user",
    "forgotPasswordCatalog":  "/api/v1/forgot-password-admin-user",
    "generateAdminCodeCatalog":  "/api/v1/generate-admin-access-code",
    "refreshTokenCatalog":  "/api/v1/refresh-token-admin",
    "dataCenterCatalog":  "/api/v1/get-datacenters",
    "getAdminUserListCatalog":  "/api/v1/get-admin-users-list",
    "addUpdateAdminUserCatalog":  "/api/v1/add-update-admin-user",
    "testConnectionCatalog":  "/api/v1/test-imanage-connection",
    "csvUpdateSendEmailCatalog":  "/api/v1/csv-update-client-users",
    "connectionData":  "/api/v1/get-imanage-connections",
    "addUpdateConnection":  "/api/v1/addupdate-imanage-connection",
    "enableDisableConnection":  "/api/v1/connection-enable-disable",
    "testSPMCredentials":  "/api/v1/spm/connections/test",
    "spmConnectionData":  "/api/v1/spm/connections/{connectionId}",
    "spmConnect":  "/api/v1/spm/connections/{connectionId}",
    "spmDisconnect":  "/api/v1/spm/connections/{connectionId}/disconnect",
    "getUserData":  "/api/v1/get-client-users-list",
    "getUserByGuid":  "/api/v1/get-client-user",
    "getUsersByEmail":  "/api/v1/get-client-users-by-email",
    "saveUserData":  "/api/v1/update-client-users",
    "getSchedulingData":  "/api/v1/get-schedule-configuration",
    "updateSchedulingData":  "/api/v1/update-schedule-configuration",
    "updateConnectionState":  "/api/v1/update-connection-state",
    "getLogoutUser":  "/api/v1/logout",
    "getUserActivities":  "/api/v1/user-activities",
    "getUserActivitiesCount":  "/api/v1/user-activities-count",
    "testBlobConnection":  "/api/v1/blob-connection/test",
    "saveLibraryBlobConnection":  "/api/v1/blob-connection"
}
